import { createStructuredSelector } from 'reselect';
import { selectedHeader,
  selectAccountID,
  selectNavBarData,
  financialAdvisorStatus,
  accountStatus,
  selectAvailableBalance
} from '../../selectors/globalSelectors';

const getMessageStates = (data) => data.messaging;
const myAccountStates = (data) => data.myAccount;
const npaStates = (data) => data.npaFormReducer;
const faDashboardStates = (data) => data.financialAdvisorDashboard;

export const getMessages = (data) => {
  const { messages } = getMessageStates(data);
  return messages;
}

export const accountDetails = (data) => {
  const { additionalAccountDetails } = getMessages(data);
  return additionalAccountDetails;
}

export const messagesData = (datas) => {
  const { data } = getMessages(datas);
  return data;
}

export const allMessages = (data) => {
  const { alldata } = getMessages(data);
  return alldata;
}

export const messagesLoaded = (data) => {
  const { isLoading } = getMessages(data);
  return isLoading;
}

export const allMessagesLoaded = (data) => {
  const { isAllLoading } = getMessages(data);
  return isAllLoading;
}

export const combinedMessages = (data) => {
  const { allMessages } = getMessages(data);
  return allMessages;
}

export const fundName = (data) => {
  const { defaultFundName } = myAccountStates(data);
  return defaultFundName;
}

export const fundNameForNPA = (data) => {
  const { fundNameUsedForNPAStatus } = npaStates(data);
  return fundNameUsedForNPAStatus;
}

export const enableRedirection = (data) => {
  const { enableBack } = faDashboardStates(data);
  return enableBack;
}

export const OOAalert = (data) => {
  const { alerts } = npaStates(data);
  return alerts;
}

export const toggle = (data) => {
  const { isToggle } = getMessages(data);
  return isToggle;
}

export const agreementFlag = (data) => {
  const { grantAgreementFlag } = accountDetails(data);
  return grantAgreementFlag;
}

export const accountRole = (data) => {
  const { accountRole } = accountDetails(data);
  return accountRole;
}

export const HeaderDerivedStates = createStructuredSelector({
  selected: selectedHeader,
  accountID: selectAccountID,
  messagesData: messagesData,
  allmessagesData: allMessages,
  isMessageLoaded: messagesLoaded,
  isAllMessageLoaded: allMessagesLoaded,
  combinedMessagesData: combinedMessages,
  defaultFund: fundName,
  account: accountStatus,
  fundNameUsedForNPAStatus: fundNameForNPA,
  navBarData: selectNavBarData,
  accountChangedOnfinacialAdvisor: financialAdvisorStatus,
  enableBack: enableRedirection,
  current: selectedHeader,
  alertOOA: OOAalert
})

export const PagesNavDerivedStates = createStructuredSelector({
  selected: selectedHeader,
  accountID: selectAccountID,
  isToggle: toggle,
  availableBalance: selectAvailableBalance,
  grantAgreementFlag: agreementFlag,
  navBarData: selectNavBarData,
  accountRole: accountRole
})

export const productTourDerivedStates = createStructuredSelector({
  accountDetails: accountDetails
});